import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import compact from 'lodash/compact'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import ConditionForm from 'modules/reports/lib/Store/FormCollections/Filter/Condition/ConditionForm'
import { hasAbility } from 'modules/reports/lib/fieldHelper'
import type { AbilityType } from 'modules/reports/store/models/types'

import Aggregation from './Types/Aggregation'
import Filtering from './Types/Filtering'
import Grouping from './Types/Grouping'
import Ordering from './Types/Ordering'

type AnyComponent = React.ComponentType<any> | string
interface Props {
  fieldType: FieldType
  types: AbilityType[]
}

const COMPONENTS = {
  aggregation: Aggregation,
  ordering: Ordering,
  grouping: Grouping,
  filtering: Filtering,
}

const FIELDS = {
  aggregation: 'function',
  grouping: 'group',
  ordering: 'order',
}

const Info = ({ fieldType, types }: Props) => {
  const getComponents = (): React.ElementType[] => {
    const filterAbility = 'filtering'

    if (includes(types, filterAbility)) {
      const form = fieldType.form

      if (!(form instanceof ConditionForm) || !form.isCompleted) {
        return []
      }

      return [COMPONENTS[filterAbility]]
    }

    return compact(
      types.map((type) => {
        if (type === filterAbility) return null

        if (fieldType.field && !hasAbility(fieldType.field, type)) return null

        const fieldKey = FIELDS[type]

        if (!fieldType.form.has(fieldKey)) return null

        const value = fieldType.form.get(fieldKey).value

        if (isEmpty(value)) return null

        return COMPONENTS[type]
      })
    )
  }

  const components = getComponents()

  if (!components.length) return null

  return (
    <Box
      background="grey100"
      borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      padding="s8"
      paddingLeft="s32"
    >
      <Box gap="s4">
        {components.map((Component: AnyComponent, index: number) => (
          <Component key={index} fieldType={fieldType} />
        ))}
      </Box>
    </Box>
  )
}

export default observer(Info)
